import classNames from 'classnames'
import PropTypes from 'prop-types'

import { Radio } from 'components/Core'

import styles from './AddSelectsToAssortmentModal.module.css'
import { AssortmentLink } from 'containers/AssortmentLink'

export const CREATE_ASSORTMENT_OPTION = 'CREATE_ASSORTMENT_OPTION'
export const UPDATE_ASSORTMENT_OPTION = 'UPDATE_ASSORTMENT_OPTION'
export const CREATE_WORKSPACE_OPTION = 'CREATE_WORKSPACE_OPTION'
export const UPDATE_WORKSPACE_OPTION = 'UPDATE_WORKSPACE_OPTION'
export const CREATE_ORDER_OPTION = 'CREATE_ORDER_OPTION'
export const UPDATE_ORDER_OPTION = 'UPDATE_ORDER_OPTION'

export const poLinkTypes = {
  OVERVIEW: '/overview',
  PRODUCTS: '/products',
}

export const labels = {
  [CREATE_ASSORTMENT_OPTION]: 'Create new Assortment',
  [UPDATE_ASSORTMENT_OPTION]: 'Add Selects to Assortment',
  [CREATE_WORKSPACE_OPTION]: 'Create new Workspace',
  [UPDATE_WORKSPACE_OPTION]: 'Add Selects to Workspace',
  [CREATE_ORDER_OPTION]: 'Create new Order',
  [UPDATE_ORDER_OPTION]: 'Add Products to Order',
}

export const messages = {
  error:
    'There was an error completing your request. Please contact support if this issue persists.',
  createSuccessAssortment: 'Your Assortment has been created.',
  updateSuccessAssortment: 'Your Assortment has been updated.',
  viewAssortment: 'Click here to view your Assortment.',
  createSuccessWorkspace: 'Your Workspace has been created.',
  updateSuccessWorkspace: 'Your Workspace has been updated.',
  viewWorkspace: 'Click here to view your Workspace.',
  createSuccessOrder: 'Your Order has been created.',
  updateSuccessOrder: 'Your Order has been updated.',
  viewOrder: 'Click here to view your Order.',
}

export const AssortmentPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
})

export const SeasonsPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
})

export const SelectionItemsContainer = ({ children }) => (
  <div className={styles.SelectionItemsContainer}>{children}</div>
)

SelectionItemsContainer.propTypes = {
  children: PropTypes.any.isRequired,
}

export const SelectionItem = ({ children, isSelected, select, title }) => (
  <div onClick={select} className={styles.SelectionItem}>
    <Radio checked={isSelected} />
    <div className={styles.title}>{title}</div>
    <div
      className={classNames([styles.content], {
        [styles.disabled]: !isSelected,
      })}
    >
      {children}
    </div>
  </div>
)

SelectionItem.propTypes = {
  children: PropTypes.any.isRequired,
  isSelected: PropTypes.bool.isRequired,
  select: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
}

export const complete = ({
  assortment,
  clearSelects,
  close,
  errors,
  loading,
  renderErrorNotification,
  renderSuccessNotification,
  setLoading,
  successMessage,
  viewMessage,
}) => {
  if (assortment) {
    close()
    clearSelects()
    renderSuccessNotification(
      <div>
        {successMessage}
        <AssortmentLink
          poLinkType={
            successMessage === messages.createSuccessAssortment ||
            successMessage === messages.createSuccessWorkspace
              ? poLinkTypes.OVERVIEW
              : poLinkTypes.PRODUCTS
          }
          assortmentId={assortment.id}
        >
          {viewMessage}
        </AssortmentLink>
      </div>,
    )
  }
  if (errors !== undefined) {
    renderErrorNotification(messages.error)
  }
  setLoading(loading)
}
